import { useValidationYupDocumento } from 'views/components/form-validations';
import * as Yup from 'yup';

export const useFormTransferirContratoValidation = () => {

    const { documentoYup } = useValidationYupDocumento(false)

    const FormTransferirContratoValidationYup = Yup.object().shape({
        cnpj: documentoYup("CNPJ")
    });

    return {
        FormTransferirContratoValidationYup,
    }
}

